import axios from "axios"

const state = {
  STATUS: null,
  API_ROUTE: "/reader",
  readersList: [],
  totalReaders: 0
}

const getters = {
  readersList: (state) => state.readersList,
  totalReaders: (state) => state.totalReaders
}

const mutations = {
  setReaders(state, readers) {
    state.readersList = readers
  },
  setTotalReaders(state, total) {
    state.totalReaders = total
  }
}

const actions = {
  async listReaders({ commit }, { offset = 0, limit = 10, search = null, orgId = null } = {}) {
    try {
      const userId = sessionStorage.getItem("userID")
      const url = `${process.env.VUE_APP_URL}${state.API_ROUTE}/list/${userId}`
      const config = {
        headers: {
          "Content-Type": "application/json"
        },
        params: { offset, limit, search, orgId }
      }
      const response = await window.axios.get(url, config)
      commit("setReaders", response.data.readers)
      commit("setTotalReaders", response.data.total)

      return response.data
    } catch (error) {
      state.STATUS = "An error occurred: " + error
      throw error
    }
  },
  async listReaderById({ commit }, { readerId }) {
    try {
      const userId = sessionStorage.getItem("userID")
      const url = `${process.env.VUE_APP_URL}${state.API_ROUTE}/${userId}/${readerId}`
      const config = {
        headers: {
          "Content-Type": "application/json"
        }
      }
      const response = await window.axios.get(url, config)
      return response.data
    } catch (error) {
      state.STATUS = "An error occurred: " + error
      throw error
    }
  },
  async addReader({ commit }, reader) {
    try {
      const userId = sessionStorage.getItem("userID")
      const url = `${process.env.VUE_APP_URL}${state.API_ROUTE}/${userId}`
      const config = {
        headers: {
          "Content-Type": "application/json"
        }
      }
      const response = await window.axios.post(url, reader, config)
      return response.data
    } catch (error) {
      state.STATUS = "An error occurred: " + error
      if (error.response && error.response.data.detail.message) {
        throw new Error(error.response.data.detail.message || "An error occurred while creating a new reader")
      }
      throw error
    }
  },
  async updateReader({ commit }, { readerId, reader }) {
    try {
      const userId = sessionStorage.getItem("userID")
      const url = `${process.env.VUE_APP_URL}${state.API_ROUTE}/${userId}/${readerId}`
      const config = {
        headers: {
          "Content-Type": "application/json"
        }
      }
      const response = await window.axios.put(url, reader, config)
      return response.data
    } catch (error) {
      state.STATUS = "An error occurred: " + error
      if (error.response && error.response.data.detail.message) {
        throw new Error(error.response.data.detail.message || "An error occurred while updating the reader")
      }

      throw error
    }
  },
  async deleteReader({ commit }, readerId) {
    try {
      const userId = sessionStorage.getItem("userID")
      const url = `${process.env.VUE_APP_URL}${state.API_ROUTE}/${userId}/${readerId}`
      const config = {
        headers: {
          "Content-Type": "application/json"
        }
      }
      const response = await window.axios.delete(url, config)
      return response.data
    } catch (error) {
      state.STATUS = "An error occurred: " + error
      throw error
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
